const version = "2.2.0"
export {version} //, commit}